"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistException = void 0;
class WishlistException extends Error {
    constructor(message) {
        super(message);
        this.name = 'WishlistException';
    }
}
exports.WishlistException = WishlistException;
